import { apolloClient } from "@td/ui";
import CREATE_TASK_NOTE_MUTATION from "../mutations/create-task-note.graphql";
import toastr from "../../toastr";
import { translate } from "@td/shared_utils";
import { isEmpty } from "lodash";

const responseSelector = ({ data: { createCareTeamTaskNote }}) => createCareTeamTaskNote;

export default async (formData) => {
  try {
    const data = await apolloClient.mutate({
      mutation: CREATE_TASK_NOTE_MUTATION,
      variables: {
        formData,
      },
    });

    if(isEmpty(data.errors)) {
      toastr.success(
        translate(null, "care_team_tasks.notifications", "task_note_added")
      );
    } else {
      toastr.error(
        translate(null, "care_team_tasks", "server_error")
      );
    }

    return responseSelector(data);
  } catch (e) {
    toastr.error(
      translate(null, "care_team_tasks", "server_error")
    );
  }
};
